import { PaymentMethodType, SupportedLocale } from '@afterpay/types'
import { Country } from '../'
import { CreditFacilityStatus, DocumentVerificationResult, IdentityCheckMetadata, IdentityCheckStatus, IdentityCheckStatuses } from '../types'

export enum ConsumerAddressType {
  SHIPPING_ADDRESS = 'SHIPPING_ADDRESS',
  BILLING_ADDRESS = 'BILLING_ADDRESS',
  CONSUMER_ACCOUNT_CONTACT_ADDRESS = 'CONSUMER_ACCOUNT_CONTACT_ADDRESS',
  MERCHANT_ADDRESS = 'MERCHANT_ADDRESS',
  STORE_ADDRESS = 'STORE_ADDRESS',
  CONSUMER_ACCOUNT_SHIPPING_ADDRESS = 'CONSUMER_ACCOUNT_SHIPPING_ADDRESS',
}

export interface ConsumerAddress {
  id: number
  name: string
  address1: string
  address2: string | null
  area2: string | null
  suburb: string
  state: string
  postcode: string
  countryCode: Country
  addressType?: ConsumerAddressType
}

export enum PreferredPaymentMethod {
  CREDIT_CARD = 'CREDIT_CARD',
  APPLE_PAY = 'APPLE_PAY',
  ACH_BANK_ACCOUNT = 'ACH_BANK_ACCOUNT',
  CASH_APP_PAY = 'CASH_APP_PAY',
}

export enum AccountStatus {
  NO_VALUE = 'NO_VALUE',
  NEW = 'NEW',
  REGISTERED = 'REGISTERED',
  UNREGISTERED = 'UNREGISTERED',
  DISABLED = 'DISABLED',
  ON_HOLD = 'ON_HOLD',
  SUSPENDED = 'SUSPENDED',
  CLOSED = 'CLOSED',
  WRITTEN_OFF = 'WRITTEN_OFF',
  HARDSHIP = 'HARDSHIP',
  PAYMENT_ARRANGEMENT = 'PAYMENT_ARRANGEMENT',
}

export interface FrozenStatus {
  accountFrozen: boolean
  selfExclusion: boolean
  selfExclusionReason: string | null
}

export interface ConsumerAccountResponse {
  id: number
  uuid: string
  givenNames: string
  otherGivenNames: string
  surname: string
  email: string
  phoneNumber: string
  contactAddress: ConsumerAddress | null
  smsVerificationRequired: boolean
  profileConfirmed: boolean
  dateOfBirth: string
  countryCode: Country
  smsVerificationEnabled: boolean
  identityCheckStatus: IdentityCheckStatus
  identityCheckStatuses: IdentityCheckStatuses
  preferredPaymentMethod: PaymentMethodType & PreferredPaymentMethod
  accountStatus: AccountStatus
  preferredLocale: SupportedLocale
  createdDate: number
  frozenStatus: FrozenStatus
  documentVerificationResults: DocumentVerificationResult[]
  creditCheckConsented?: boolean
  identityCheckMetadata?: IdentityCheckMetadata
  latestFacilityStatus?: CreditFacilityStatus
}

export interface ForcePasswordResetSendLinkRequest {
  consumerEmail: string
}
export interface ForcePasswordResetLinkCheckRequest {
  link: string
}
export interface ForcePasswordResetLinkCheckResponse {
  isExpired: boolean
  consumerEmail?: string
  consumerName?: string
  consumerMobile?: string
  source?: string
}
export interface ForcePasswordResetRequest {
  newPassword: string
  link: string
}
export interface EmailSurveyLinkCheckRequest {
  link: string
}
export interface EmailSurveyLinkCheckResponse {
  isExpired: boolean
  consumerName: string
  consumerMobile: string
}
export interface EmailSurveySendCodeRequest {
  link: string
}
export interface EmailSurveyCheckCodeRequest {
  link: string
  code: string
}
export interface ConsumerLogoutResponse {
  status: boolean
}

export interface DeviceDetails {
  ce: boolean
  cn: string
  je: boolean
  l: string
  o: boolean
  os: string
  plugins: object
  screen: object
  tz: number
  ua: string
  v: string
}

export interface FinaliseAccountRequest {
  address1: string
  address2?: string
  area2: string
  countryCode: Country
  dateOfBirth: string
  givenNames: string
  mobile: string
  otherGivenNames: string
  postcode: string
  state?: string
  suburb: string
  surname: string
  creditPolicyAgree?: boolean
  creditCheckAgree?: boolean
  providedCreditCheckConsent?: boolean
}
/**
 * Types from packages
 */
export * from './account/creditcards/types'
export * from './account/change-password/types'
export * from './amountDueSummary/types'
export * from './checkout/types'
export * from './creditCheck/types'
export * from './creditLimit/types'
export * from './ordertransactions/types'
export * from './paymentReschedule/types'
export * from './paymentSchedule/types'
export * from './ppa/types'
export * from './subscriptions/marketing/types'
export * from './threeDS/types'
export * from './enabledCards/types'
export * from './creditFacility/types'
export * from './account/bank-accounts/types'
export * from './account/cash-app-pays/types'
export * from './oauth/types'
export * from './sessions/types'
export * from './plus-card/types'
export * from './loyalty/types'
export * from './tags/types'
